import script from "./SampleRequestListView.vue?vue&type=script&setup=true&lang=js"
export * from "./SampleRequestListView.vue?vue&type=script&setup=true&lang=js"

import "./SampleRequestListView.vue?vue&type=style&index=0&id=8bef4756&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bef4756"]])

export default __exports__